let notification = require(`notification`),
  loader = require(`loader`),
  getUrlParameter = require(`getUrlParameter`),
  authenticationService = require(`authenticationService`);

const userLogin = (function() {
  const checkUserDetails = function() {
    function checkCookiesEnabled() {
      let isEnabled = navigator.cookieEnabled;
      if (typeof navigator.cookieEnabled === `undefined` && !isEnabled) {
        document.cookie = `tcookie`;
        isEnabled = document.cookie.indexOf(`tcookie`) !== -1;
      }
      return isEnabled;
    }
    const item = new Object();
    item.emailAddress = $(`#email_address`).val();
    item.password = $(`#password`).val();
    item.cookiesEnabled = checkCookiesEnabled();
    const data = JSON.stringify(item);

    loginUserService(data, loginUserResponse, loginUserErrorResponse);
  };

  var loginUserResponse = function(response) {
    if (response.statusCode === 200) {
      $(`.left-panel`).removeClass(`has-error`);
      $(`window`).notification({
        title: `Login success.`,
      });
      const url = $(`window`).getUrlParameter(`returnPath`);
      if (url != null) {
        window.location = url;
      } else {
        window.location = `/locker`;
      }
    } else {
      $(`.left-panel`).addClass(`has-error`);
      $(`window`).notification({
        title: `Could not login. Error: ${response.message}`,
        error: true,
      });
    }
  };

  var loginUserErrorResponse = function() {
    $(`window`).notification({
      title: `Unable to login to the server at this time. Please try again or <a href="mailto:help@thecoachingmanual.com?subject=Cannot login">contact us if the problem persists</a>.`,
      error: true,
    });
  };

  const submitForm = function() {
    $(`#login-form`).on(`submit`, function(e) {
      e.preventDefault();
      $(`window`).showLoader();
      checkUserDetails();
    });
  };

  const init = function() {
    submitForm();
  };

  return {
    init,
  };
}());

if ($(`#login-form`).length) {
  userLogin.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/login/login.js